export default __webpack_public_path__ + "static/N0250-002a799a67fb32970b58699d22dc2125.png";